import React, { Component } from 'react';
import Slider from 'react-slick';
import { StaticImage } from 'gatsby-plugin-image';

export default class ProjectSliderW extends Component {
  // componentDidMount() {
  //   $('.slick-slide').click(function(e) {
  //     $('.slick-slide').slick('slickNext');
  //   });
  // }

  render() {
    const settings = {
      dots: false,
      // slidesToShow: 3,
      arrows: false,
      // centerMode: true,
      // speed: 3000,
      // autoplay: true,
      // centerPadding: '50px',
      speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      responsive: [
        {
          breakpoint: 770,
          settings: {
            slidesToShow: 2,
            centerMode: true,
            centerPadding: '30px',
          },
        },
      ],
    };
    // $('.slick-slide').click(function(e) {
    //   $('.slick-slide').slick('slickNext');
    // });
    return (
      <div>
        <Slider {...settings}>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/lemosta_1.jpg"
              alt="レモンスタンド広島"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/lemosta_2.jpg"
              alt="レモンスタンド広島"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/lemosta_3.jpg"
              alt="レモンスタンド広島"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/lemosta_4.jpg"
              alt="レモンスタンド広島"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/lemosta_5.jpg"
              alt="レモンスタンド広島"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/lemosta_11.jpg"
              alt="レモンスタンド広島"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/lemosta_6.jpg"
              alt="レモンスタンド広島"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/lemosta_7.jpg"
              alt="レモンスタンド広島"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/lemosta_12.jpg"
              alt="レモンスタンド広島"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/lemosta_8.jpg"
              alt="レモンスタンド広島"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/lemosta_9.jpg"
              alt="レモンスタンド広島"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/lemosta_10.jpg"
              alt="レモンスタンド広島"
              placeholder="blurred"
            />
          </div>

          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/monto_1.jpg"
              alt="mon-to.9"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/monto_2.jpg"
              alt="mon-to.9"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/monto_3.jpg"
              alt="mon-to.9"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/monto_10.jpg"
              alt="mon-to.9"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/monto_4.jpg"
              alt="mon-to.9"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/monto_5.jpg"
              alt="mon-to.9"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/monto_7.jpg"
              alt="mon-to.9"
              placeholder="blurred"
            />
          </div>

          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/monto_9.jpg"
              alt="mon-to.9"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/monto_8.jpg"
              alt="mon-to.9"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/monto_6.jpg"
              alt="mon-to.9"
              placeholder="blurred"
            />
          </div>
        </Slider>
      </div>
    );
  }
}
